import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Layout } from "@/components/layout/Layout";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { API } from "@/hooks/useAuth";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await axios.post(`${API}/auth/password-reset/request`, { email: email.trim() });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Layout>
      <section className="max-w-md mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <p className="text-xs uppercase tracking-widest text-muted-foreground">Account recovery</p>
        <h1 className="font-display text-4xl mt-1">Forgot your password?</h1>
        <p className="text-muted-foreground mt-2 text-sm">
          Enter the email on your account and we&apos;ll send you a reset link.
        </p>

        <Card className="mt-8 p-6">
          {done ? (
            <div data-testid="forgot-password-success" className="space-y-3">
              <p className="text-sm">
                If <strong>{email}</strong> matches a Play Tsoro account, a reset
                link is on its way. Check your inbox (and spam folder). The link
                is valid for 60 minutes.
              </p>
              <Link to="/login" className="text-primary hover:underline text-sm">
                Back to sign in →
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-1.5">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  data-testid="forgot-password-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  required
                />
              </div>
              {error && <p className="text-sm text-destructive">{error}</p>}
              <Button
                data-testid="forgot-password-submit"
                type="submit"
                disabled={busy}
                className="w-full rounded-full"
              >
                {busy ? "Sending…" : "Send reset link"}
              </Button>
              <p className="text-sm text-center">
                <Link to="/login" className="text-muted-foreground hover:text-primary hover:underline">
                  Back to sign in
                </Link>
              </p>
            </form>
          )}
        </Card>
      </section>
    </Layout>
  );
}
